import React, { useState } from 'react';
import { formatCurrency } from '../../utils/currencyFormatter';
import { TicketIcon, PlusIcon, SaveIcon, XIcon, CheckIcon, UserIcon, ClockIcon } from 'lucide-react';
export function OccasionalPasses({
  locale,
  onAddPasses,
  showPassForm,
  setShowPassForm
}) {
  // Mock data for pass balance
  const [passBalance, setPassBalance] = useState({
    currentCount: 42,
    pricePerPass: 25,
    currency: 'USD',
    expiryHours: 12
  });
  // Mock data for pass purchases
  const [purchases, setPurchases] = useState([{
    id: 'purchase-1',
    date: '2023-09-01T10:00:00Z',
    count: 50,
    pricePerPass: 25,
    totalPrice: 1250,
    currency: 'USD',
    purchasedBy: 'John Smith'
  }, {
    id: 'purchase-2',
    date: '2023-10-15T14:30:00Z',
    count: 10,
    pricePerPass: 25,
    totalPrice: 250,
    currency: 'USD',
    purchasedBy: 'Jane Doe'
  }]);
  // Mock data for pass usage
  const [passUsage, setPassUsage] = useState([{
    id: 'pass-1',
    userId: 'user-001',
    userName: 'Michael Johnson',
    startTime: '2023-10-20T09:15:00Z',
    expiryTime: '2023-10-20T21:15:00Z',
    active: false
  }, {
    id: 'pass-2',
    userId: 'user-002',
    userName: 'Sarah Williams',
    startTime: '2023-10-21T10:30:00Z',
    expiryTime: '2023-10-21T22:30:00Z',
    active: false
  }, {
    id: 'pass-3',
    userId: 'user-003',
    userName: 'Robert Brown',
    startTime: '2023-10-22T08:45:00Z',
    expiryTime: '2023-10-22T20:45:00Z',
    active: true
  }]);
  // Form state for purchasing passes
  const [formData, setFormData] = useState({
    count: 10,
    pricePerPass: passBalance.pricePerPass
  });
  // Calculate total price
  const totalPrice = formData.count * formData.pricePerPass;
  // Handle form field changes
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    if (name === 'count') {
      setFormData({
        ...formData,
        count: parseInt(value, 10) || 0
      });
    }
  };
  // Handle price change
  const handlePriceChange = e => {
    const {
      value
    } = e.target;
    // Remove non-numeric characters except decimal point
    const sanitizedValue = value.replace(/[^\d.]/g, '');
    const priceValue = parseFloat(sanitizedValue || '0');
    if (!isNaN(priceValue)) {
      setFormData({
        ...formData,
        pricePerPass: priceValue
      });
    }
  };
  // Handle form submission
  const handleSubmit = e => {
    e.preventDefault();
    // Create new purchase
    const newPurchase = {
      id: `purchase-${new Date().getTime()}`,
      date: new Date().toISOString(),
      count: formData.count,
      pricePerPass: formData.pricePerPass,
      totalPrice: totalPrice,
      currency: passBalance.currency,
      purchasedBy: 'Admin'
    };
    // Update purchases and pass balance
    setPurchases([newPurchase, ...purchases]);
    setPassBalance({
      ...passBalance,
      currentCount: passBalance.currentCount + formData.count
    });
    // Reset form
    setShowPassForm(false);
  };
  return <div className="space-y-8" data-id="element-17793">
      {showPassForm ? <div className="bg-white shadow sm:rounded-lg" data-id="element-17794">
          <div className="px-4 py-5 sm:p-6" data-id="element-17795">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-17796">
              Purchase Occasional Passes
            </h3>
            <form className="mt-5 space-y-6" onSubmit={handleSubmit} data-id="element-17797">
              <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-17798">
                <div className="sm:col-span-3" data-id="element-17799">
                  <label htmlFor="count" className="block text-sm font-medium text-gray-700" data-id="element-17800">
                    Number of Passes
                  </label>
                  <div className="mt-1" data-id="element-17801">
                    <input type="number" name="count" id="count" value={formData.count} onChange={handleChange} min="1" className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" required data-id="element-17802" />
                  </div>
                </div>
                <div className="sm:col-span-3" data-id="element-17803">
                  <label htmlFor="pricePerPass" className="block text-sm font-medium text-gray-700" data-id="element-17804">
                    Price Per Pass
                  </label>
                  <div className="mt-1" data-id="element-17805">
                    <div className="flex rounded-md shadow-sm" data-id="element-17806">
                      <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm" data-id="element-17807">
                        {passBalance.currency}
                      </span>
                      <input type="text" name="pricePerPass" id="pricePerPass" value={formData.pricePerPass} onChange={handlePriceChange} pattern="^\d*(\.\d{0,2})?$" placeholder="0.00" className="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300" required data-id="element-17808" />
                    </div>
                  </div>
                </div>
                <div className="sm:col-span-6" data-id="element-17809">
                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-17810">
                    <div className="flex justify-between" data-id="element-17811">
                      <span className="text-sm font-medium text-gray-500" data-id="element-17812">
                        Total Price:
                      </span>
                      <span className="text-lg font-bold text-gray-900" data-id="element-17813">
                        {formatCurrency(totalPrice, passBalance.currency, locale)}
                      </span>
                    </div>
                    <div className="mt-2 text-xs text-gray-500" data-id="element-17814">
                      Passes expire {passBalance.expiryHours} hours after
                      activation
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end space-x-3" data-id="element-17815">
                <button type="button" onClick={() => setShowPassForm(false)} className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-17816">
                  Cancel
                </button>
                <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-17817">
                  <SaveIcon className="h-4 w-4 mr-2" data-id="element-17818" />
                  Purchase Passes
                </button>
              </div>
            </form>
          </div>
        </div> : <>
          {/* Pass Balance Card */}
          <div className="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200" data-id="element-17819">
            <div className="px-4 py-5 sm:px-6" data-id="element-17820">
              <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-17821">
                Occasional Pass Balance
              </h3>
              <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-17822">
                Current balance and pass information
              </p>
            </div>
            <div className="px-4 py-5 sm:p-6" data-id="element-17823">
              <div className="sm:flex sm:items-center sm:justify-between" data-id="element-17824">
                <div className="flex items-center" data-id="element-17825">
                  <div className="flex-shrink-0 bg-green-100 rounded-md p-3" data-id="element-17826">
                    <TicketIcon className="h-6 w-6 text-green-600" data-id="element-17827" />
                  </div>
                  <div className="ml-5" data-id="element-17828">
                    <h4 className="text-lg font-bold text-gray-900" data-id="element-17829">
                      {passBalance.currentCount} passes
                    </h4>
                    <p className="text-sm text-gray-500" data-id="element-17830">
                      {formatCurrency(passBalance.pricePerPass, passBalance.currency, locale)}{' '}
                      per pass
                    </p>
                  </div>
                </div>
                <div className="mt-5 sm:mt-0" data-id="element-17831">
                  <button type="button" onClick={onAddPasses} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-17832">
                    <PlusIcon className="h-4 w-4 mr-2" data-id="element-17833" />
                    Purchase Passes
                  </button>
                </div>
              </div>
              <div className="mt-5 border-t border-gray-200 pt-5" data-id="element-17834">
                <dl className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2" data-id="element-17835">
                  <div className="sm:col-span-1" data-id="element-17836">
                    <dt className="text-sm font-medium text-gray-500" data-id="element-17837">
                      Pass Validity
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900" data-id="element-17838">
                      {passBalance.expiryHours} hours
                    </dd>
                  </div>
                  <div className="sm:col-span-1" data-id="element-17839">
                    <dt className="text-sm font-medium text-gray-500" data-id="element-17840">
                      Used This Month
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900" data-id="element-17841">
                      {passUsage.length} passes
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-17842">
            {/* Purchases Section */}
            <div className="bg-white shadow sm:rounded-lg" data-id="element-17843">
              <div className="px-4 py-5 sm:px-6" data-id="element-17844">
                <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-17845">
                  Pass Purchases
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-17846">
                  History of pass purchases
                </p>
              </div>
              <div className="border-t border-gray-200" data-id="element-17847">
                <div className="overflow-hidden overflow-x-auto" data-id="element-17848">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-17849">
                    <thead className="bg-gray-50" data-id="element-17850">
                      <tr data-id="element-17851">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17852">
                          Date
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17853">
                          Passes
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17854">
                          Total
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17855">
                          Purchased By
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-17856">
                      {purchases.map(purchase => <tr key={purchase.id} data-id="element-17857">
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-17858">
                            {new Date(purchase.date).toLocaleDateString(locale)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-17859">
                            {purchase.count}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-17860">
                            {formatCurrency(purchase.totalPrice, purchase.currency, locale)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-17861">
                            {purchase.purchasedBy}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                  {purchases.length === 0 && <div className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-17862">
                      No purchase history found.
                    </div>}
                </div>
              </div>
            </div>
            {/* Usage Section */}
            <div className="bg-white shadow sm:rounded-lg" data-id="element-17863">
              <div className="px-4 py-5 sm:px-6" data-id="element-17864">
                <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-17865">
                  Pass Usage
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-17866">
                  Recent pass usage by users
                </p>
              </div>
              <div className="border-t border-gray-200" data-id="element-17867">
                <div className="overflow-hidden overflow-x-auto" data-id="element-17868">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-17869">
                    <thead className="bg-gray-50" data-id="element-17870">
                      <tr data-id="element-17871">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17872">
                          User
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17873">
                          Start Time
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17874">
                          Expiry
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17875">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-17876">
                      {passUsage.map(pass => <tr key={pass.id} data-id="element-17877">
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-17878">
                            <div className="flex items-center" data-id="element-17879">
                              <div className="flex-shrink-0 h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-17880">
                                <UserIcon className="h-5 w-5 text-gray-500" data-id="element-17881" />
                              </div>
                              <div className="ml-4" data-id="element-17882">
                                <div className="text-sm font-medium text-gray-900" data-id="element-17883">
                                  {pass.userName}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-17884">
                            {new Date(pass.startTime).toLocaleString(locale)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-17885">
                            {new Date(pass.expiryTime).toLocaleString(locale)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-17886">
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${pass.active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-17887">
                              {pass.active ? <>
                                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17888" />
                                  Active
                                </> : <>
                                  <CheckIcon className="h-3 w-3 mr-1" data-id="element-17889" />
                                  Completed
                                </>}
                            </span>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                  {passUsage.length === 0 && <div className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-17890">
                      No pass usage found.
                    </div>}
                </div>
              </div>
            </div>
          </div>
        </>}
    </div>;
}